import { AbstractModel } from '@patsnap/tahiti-core/common/model';
import type { Disposable } from '@patsnap/tahiti-core';
import type { OriginalInputState } from '../types';

export const OriginalInputModel = Symbol('OriginalInputModel');

export interface OriginalInputModel extends AbstractModel<OriginalInputState>, Disposable { }
